import ProjectWorkspacePage from "../../shared/projectWorkspace/ProjectWorkspacePage";

const ManagementProjectWorkspacePage = () => (
  <ProjectWorkspacePage configKey="management" />
);

export default ManagementProjectWorkspacePage;
